module.exports = __webpack_public_path__ + "static/media/winter_super_pack_dog_FR.c8752a44.png";